//#region src/utils/createQueryParams.ts
var e = (e) => {
	if (!e) return "";
	let t = Object.entries(e).reduce((e, [t, n]) => n == null ? e : {
		...e,
		[t]: n.toString()
	}, {});
	return Object.keys(t).length === 0 ? "" : `?${new URLSearchParams(t).toString()}`;
};
//#endregion
export { e as t };

//# sourceMappingURL=createQueryParams-D2aMgLX5.js.map